import React, { useEffect, useRef } from 'react';
import { ISelectOption } from '@creditflowresearch/uilib/Select';
import { useRouter } from '@framework/router';
import { useLeagueTableContext } from '@/creditflowresearch/application/League/Table/LeagueTableContext';
import { useLeagueTableFiltersContext } from '@/creditflowresearch/application/League/Table/LeagueTableFiltersContext';
import { usePageFiltersStateContext } from '@/creditflowresearch/application/PageFiltersState/PageFiltersStateContext';
import TTMSelect from '@/creditflowresearch/ui/common/components/atoms/TTMSelect';

const TopRatingAgenciesTTMSelect = () => {
  const { query: { products, regions } } = useRouter();
  const didMount = useRef(false);
  const { paginateTopRatingAgencies } = useLeagueTableContext();
  const {
    state: filtersState,
    getTopRatingAgenciesPeriods,
    resetTopRatingAgenciesPeriod,
    setTopRatingAgenciesPeriod,
  } = useLeagueTableFiltersContext();

  const selectedPeriod = filtersState.periods.topRatingAgencies.selected;
  const periodsCollection = filtersState.periods.topRatingAgencies.collection;

  const {
    state: {
      productIds: includedProductIds,
      regionIds: includedRegionIds,
    },
  } = usePageFiltersStateContext();

  const onChange = (option: ISelectOption): void => {
    if (option) {
      setTopRatingAgenciesPeriod(option);
      paginateTopRatingAgencies(1);
    }
  };

  useEffect(() => () => {
    resetTopRatingAgenciesPeriod();
  }, []);

  useEffect(() => {
    if (didMount.current) {
      getTopRatingAgenciesPeriods({ includedProductIds, includedRegionIds });
    } else {
      didMount.current = true;
    }
  }, [products, regions]);

  return (
    <TTMSelect
      value={ selectedPeriod }
      options={ periodsCollection }
      onChange={ onChange }
      isOptionDisabled={ (option) => option.disabled }
      dataTest="topRatingAgenciesTTMFilter"
    />
  );
};

export default TopRatingAgenciesTTMSelect;
